// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
// 引入element
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
// 路由
import router from './router'
// vuex状态管理
import store from '@/utils/store/store'
 
Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(ElementUI);
new Vue({
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js